const contactUs = {
    contactUs: {
        pageTitle: 'Contact Us ',
        pageDescription: 'IOPS 지상국 사용에 대한 상담이 필요하신가요?',
        descriptionBanner: '문의 사항과 연락처를 남겨주시면 빠르게 회신드리겠습니다.',
        form: {
            inquiryType: '문의 유형',
            name: '제목',
            company: '회사 / 부서',
            country: '국가',
            email: '이메일',
            inquiry: '문의 내용',
            agree: '개인정보 처리방침 및 이용약관을 확인하고 동의합니다.\n하단의 약관을 확인해 주세요.',
            submit: '제출하기'
        },
        placeholder: {
            country: '국가를 선택하세요'
        },
        inquiryType: {
            use: '지상국 사용 문의',
            share: '지상국 공유 제안 문의',
            estimate: '견적 요청',
            press: '보도/언론 문의',
            other: '기타(문의)'
        }
    }
}

export default contactUs;